import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.69",
  cy: "18.9",
  r: "18.64",
  style: {"fill":"#aca199","stroke-width":"0"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.66 11.75h2.46l-5.36 6.13 6.31 8.34h-4.94l-3.87-5.06-4.42 5.06h-2.46l5.74-6.56-6.05-7.91h5.06l3.5 4.62 4.05-4.62h-.02Zm-.86 13h1.36l-8.78-11.61h-1.46l8.88 11.61Z",
  style: {"fill":"#32312f","stroke-width":"0"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }